// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.11.0",
  date: "2026-10-01T09:17:50.758Z",
  gitInfo: {
    dirty: false,
    raw: "3f1b12f87",
    hash: "3f1b12f87",
    distance: null,
    tag: null,
    semver: null,
    suffix: "3f1b12f87",
    semverString: null
  }
};
/* tslint:enable */
